import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectBlockState } from './block.selectors';

export const selectSystemPlantCardComponent = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.PlantCardComponent
);

export const selectPlantCardStateBySystemId = (systemId: string) => createSelector(
  selectSystemPlantCardComponent,
  (systemPlantCardComponent) => systemPlantCardComponent[systemId]
);

export const selectPlantCardAlertStateBySystemId = (systemId: string) => createSelector(
  selectSystemPlantCardComponent,
  (systemPlantCardComponent) => {
    return systemPlantCardComponent[systemId]?.hasAlarms
  }
);

export const selectPlantCardBlocksToShowBySystemId = (systemId: string) => createSelector(
  selectSystemPlantCardComponent,
  (systemPlantCardComponent) => {
    return systemPlantCardComponent[systemId]?.blocksToShow
  }
);
